exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-knglistsource-tb-title{color:var(--color-primary-6);cursor:pointer}\n", ""]);

